/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Manager} from './Manager';
import {Term} from './Term';

export interface DamElasticDTO {
  id: number;
  header: string;
  syncUid?: string;
  content?: string;
  enabled: boolean;
  catalogId?: number;
  terms?: Term[];
  createdAt?: Date;
  updatedAt?: Date;
  deleted?: boolean;
  features?: any;
  rolesAndUsersRead?: string[];
  manager?: Manager;
  isImage?: boolean;
  isText?: boolean;
  isVideo?: boolean;
  previewImage?: string;
  mimeType?: string;
  currentDamItemVersionId?: number;
  icon?: string;
  countVersion?: number;
  approved: boolean;
  managerName: string;
  approvedManagerName: string;
  tagsForPreview: any[];
  deletedAt: string;
  approvedAt: string;
}
